import React from 'react';

const OpenNow = ({ color = 'var(--color-primary)' }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="19"
    height="19"
    viewBox="0 0 19 19"
  >
    <path
      fill={color}
      fillRule="evenodd"
      d="M9.5 17.396c-4.361 0-7.895-3.535-7.895-7.895 0-4.36 3.534-7.896 7.895-7.896 4.36 0 7.895 3.535 7.895 7.896 0 4.36-3.535 7.895-7.895 7.895zM9.5 0C14.746 0 19 4.253 19 9.501 19 14.747 14.746 19 9.5 19 4.253 19 0 14.747 0 9.501 0 4.253 4.253 0 9.5 0zm0 3.211c-.444 0-.803.36-.803.804v5.478c-.001.209.075.417.235.576l3.878 3.878c.157.158.361.235.568.235.205 0 .41-.077.567-.235.313-.313.313-.821 0-1.134L10.302 9.17V4.015c0-.444-.358-.804-.802-.804z"
    />
  </svg>
);

export default OpenNow;
